import React from "react";

const ReportIcon = ({ ...props }) => {
  return (
    <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.6284 3.76004L8.02567 0.157366C7.92523 0.0569197 7.78962 0 7.64732 0H0.535714C0.239397 0 0 0.239397 0 0.535714V14.4643C0 14.7606 0.239397 15 0.535714 15H11.25C11.5463 15 11.7857 14.7606 11.7857 14.4643V4.14007C11.7857 3.99777 11.7288 3.86049 11.6284 3.76004ZM10.5502 4.38616H7.39956V1.23549L10.5502 4.38616ZM10.5804 13.7946H1.20536V1.20536H6.26116V4.82143C6.26116 5.00791 6.33524 5.18675 6.4671 5.31861C6.59896 5.45047 6.77781 5.52455 6.96429 5.52455H10.5804V13.7946ZM5.75893 9.27455H2.67857C2.60491 9.27455 2.54464 9.33482 2.54464 9.40848V10.2121C2.54464 10.2857 2.60491 10.346 2.67857 10.346H5.75893C5.83259 10.346 5.89286 10.2857 5.89286 10.2121V9.40848C5.89286 9.33482 5.83259 9.27455 5.75893 9.27455ZM2.54464 7.1317V7.93527C2.54464 8.00893 2.60491 8.0692 2.67857 8.0692H9.10714C9.18081 8.0692 9.24107 8.00893 9.24107 7.93527V7.1317C9.24107 7.05804 9.18081 6.99777 9.10714 6.99777H2.67857C2.60491 6.99777 2.54464 7.05804 2.54464 7.1317Z"
        fill="#353D48"
      />
    </svg>
  );
};

export default ReportIcon;
